import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 客服账号 / 角色 / 权限管理（controller/admin：/v1/admin/**）
 */

/** 客服账号分页 */
export function listAgents(params) {
  return axios.get(`${base.url}/service/v1/admin/agents`, { params })
}

/** 新建客服账号（username/password/nickname/role/maxSessions） */
export function createAgent(data) {
  return axios.post(`${base.url}/service/v1/admin/agents`,
    JSON.stringify(data),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 更新客服账号 */
export function updateAgent(id, data) {
  return axios.put(`${base.url}/service/v1/admin/agents/${id}`,
    JSON.stringify(data),
    { headers: { 'Content-Type': 'application/json' } })
}

/** 启用/停用客服账号 */
export function toggleAgentStatus(id) {
  return axios.post(`${base.url}/service/v1/admin/agents/${id}/toggle-status`)
}

/** 删除客服账号 */
export function deleteAgent(id) {
  return axios.delete(`${base.url}/service/v1/admin/agents/${id}`)
}

/** 权限码列表（cs:*） */
export function listPermissions() {
  return axios.get(`${base.url}/service/v1/admin/permissions`)
}

/** 角色列表（含其权限码） */
export function listRoles() {
  return axios.get(`${base.url}/service/v1/admin/roles`)
}

/** 更新角色权限 */
export function updateRolePermissions(role, permissions) {
  return axios.put(`${base.url}/service/v1/admin/roles/${role}/permissions`,
    JSON.stringify({ permissions }),
    { headers: { 'Content-Type': 'application/json' } })
}